import { 
    PixelObject, 
    handleFloat
} from '../index.js'

export default class Text extends PixelObject {
    constructor(options) {
        super(options);

        const defaults = {
            type: 'TEXT',
            name: 'Text',
            width: 300,
            height: 300,
            textSize: 32,
            text: 'What if lorem ipsum patiesībā ir ļoti rupji lamu vārdi',
            textStyle: 'Normal',
            textAlign: 'Left'
        }

        const opts = { ...defaults, ...options }

        this.type = opts.type
        this.name = opts.name
        this.width = opts.width
        this.height = opts.height
        this.textSize = opts.textSize
        this.text = opts.text
        this.textStyle = opts.textStyle
        this.textAlign = opts.textAlign

        // Currently unused because this should be set based on text size 
        // this.textLeading = props ? props.textLeading : 0 
    }

    set(key, newValue) {
        let config = {
            textSize: handleFloat,
            text: (data) => { return data.newValue },
            textStyle: (data) => { return data.newValue },
            textAlign: (data) => { return data.newValue }
        }

        if (config[key]) {
            const oldValue = this[key]
            let parsedValue = config[key]({ newValue, oldValue })
          
            if (oldValue != parsedValue) {
                this[key] = parsedValue
                this.dispatch('objectStateChanged', this.propertyChangedMessage(key))
            }
        } else {
            return PixelObject.prototype.set.call(this, key, newValue)
        }
    }

    copy(args) {
        return new Text({ ...this, ...args, skipParentGeneration: true })
    }

    draw() {
        if (this.visible == '0' || this.deleted) return

        this.ctx.push()

        this.stroke()
        this.fill()

        if (this.textStyle == 'Normal' || this.textStyle == 'Italic' || this.textStyle == 'Bold' || this.textStyle == 'BoldItalic') {
            this.ctx.textStyle(this.ctx[this.textStyle.toUpperCase()])
        }

        if (this.textAlign == 'Left' || this.textAlign == 'Center' || this.textAlign == 'Right') {
            this.ctx.textAlign(this.ctx[this.textAlign.toUpperCase()])
        }

        this.position()

        this.ctx.textSize(this.textSize);

        this.ctx.text(this.text,0 ,0 , this.width, this.height);

        this.ctx.pop()
    }
}